export default "__VITE_ASSET__BaGLODaT__"